import { render, staticRenderFns } from "./MapIntroCard.vue?vue&type=template&id=0f2a70a9&scoped=true&"
import script from "./MapIntroCard.vue?vue&type=script&lang=js&"
export * from "./MapIntroCard.vue?vue&type=script&lang=js&"
import style0 from "./MapIntroCard.vue?vue&type=style&index=0&id=0f2a70a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a70a9",
  null
  
)

export default component.exports